import styled from 'styled-components';

export const Content = styled.div``;

/**
 * The gap between the rail's controls.
 *
 * It was a `<Gap size="10px" />` element between each pair — a spacer in the
 * markup rather than spacing on the thing being spaced. The controls carry
 * their own now, on the scale.
 */
export const Field = styled.div`
  margin-top: var(--s4);
`;
